"use client"

import { useRef } from "react"
import { Modal, Button, Form } from "@douyinfe/semi-ui"
import type { FormApi } from '@douyinfe/semi-ui/lib/es/form/interface';
import toast from 'react-hot-toast';
import { useModal } from "./Provdier"
import { useRegister } from "@/hooks/useUser"
import SendCodeButton from "./SendCodeButton"
import { IData } from "@/types";
import './index.css'

export default function Register({ data }: { data: IData }) {
  const { isRegisterOpen, setIsRegisterOpen, setIsLoginOpen } = useModal()
  const { register, registerLoading } = useRegister();

  const formApiRef = useRef<FormApi<{ phone: string, verificationCode: string, password: string, newpassword: string, activateCode: string }>>(null)

  // 注册提交
  async function handleSubmit() {
    formApiRef.current?.validate().then(async values => {
      try {
        await register(values);
        toast.success("注册成功");
        setIsRegisterOpen(false);
      } catch (err: any) {
        toast.error(err.msg || "注册失败");
      }
    })
  }

  function FooterComponent() {
    return (
      <div className="w-full flex justify-start flex-col">
        <Button loading={registerLoading} theme="solid" className="bg-black!" block size="large" style={{ marginLeft: 0 }} type="primary" htmlType="submit" onClick={handleSubmit} >立即注册</Button>
        <div className="text-sm text-gray-500 mx-auto pt-4">已有账号？<span className="text-blue-500 cursor-pointer" onClick={() => {
          setIsLoginOpen(true)
          setIsRegisterOpen(false)
        }}>立即登录</span></div>
      </div>
    )
  }

  function RegisterForm() {
    return (
      <Form
        getFormApi={formApi => (formApiRef.current = formApi)}
        className="pb-10"
        autoComplete="off"
      >
        <Form.Input
          autoComplete="off"
          trigger='blur'
          rules={[
            { required: true, message: '请输入手机号' },
            { validator: (rule, value) => value?.length === 11, message: '请填写正确的手机号' }
          ]}
          field='phone'
          label='手机号'
          style={{ width: '100%' }}
          size="large"
          placeholder='请输入手机号'
        />
        <Form.Input
          rules={[
            { required: true, message: '请输入验证码' }
          ]}
          field='verificationCode'
          label='验证码'
          style={{ width: '100%' }}
          size="large"
          placeholder='请输入验证码'
          suffix={
            <SendCodeButton
              getPhone={() => formApiRef.current?.getValue("phone") || ""}
            />
          }
        />
        <Form.Input
          rules={[
            { required: true, message: '请输入密码' }
          ]}
          autoComplete="off"
          field='password'
          mode="password"
          label='密码'
          style={{ width: '100%' }}
          size="large"
          placeholder='请输入密码'
        />
        <Form.Input
          rules={[
            { required: true, message: '请再次输入密码' },
            {
              validator: (rule, value) => {
                return value === formApiRef.current?.getValue("password")
              },
              message: '两次输入的密码不一致'
            }
          ]}
          field='newpassword'
          mode="password"
          label='重复密码'
          style={{ width: '100%' }}
          size="large"
          placeholder='请再次输入密码'
        />
        {
          data.activateCodeFlag && (
            <Form.Input
              rules={[{ required: true, message: '请输入兑换码' }]}
              field='activateCode'
              label='兑换码'
              style={{ width: '100%' }}
              size="large"
              placeholder='请输入兑换码'
            />
          )
        }

      </Form>
    )
  }

  return (
    <>
      <Modal
        footer={FooterComponent()}
        title="注册"
        visible={isRegisterOpen}
        hasCancel={false}
        onCancel={() => setIsRegisterOpen(false)}
        closeOnEsc={false}
        maskClosable={false}
        modalContentClass="!w-[90%] mx-auto sm:!w-[440px]"
      >
        <RegisterForm />
      </Modal>
    </>
  )
}
